function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.53 5.47L10.53 0.47C10.237 0.177 9.762 0.177 9.47 0.47L4.47 5.47C4.176 5.763 4.176 6.238 4.47 6.53C4.764 6.822 5.237 6.824 5.53 6.53L9.25 2.81V13C9.25 13.414 9.586 13.75 10 13.75C10.414 13.75 10.75 13.414 10.75 13V2.81L14.47 6.53C14.616 6.677 14.808 6.75 15 6.75C15.192 6.75 15.384 6.678 15.53 6.53C15.823 6.237 15.823 5.763 15.53 5.47Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.708 19.944H2.292C1.028 19.944 0 18.916 0 17.652V12C0 11.586 0.336 11.25 0.75 11.25C1.164 11.25 1.5 11.586 1.5 12V17.652C1.5 18.089 1.855 18.444 2.292 18.444H17.708C18.145 18.444 18.5 18.089 18.5 17.652V12C18.5 11.586 18.836 11.25 19.25 11.25C19.664 11.25 20 11.586 20 12V17.652C20 18.916 18.972 19.944 17.708 19.944Z"
});

var SvgTweetOptions = function SvgTweetOptions(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTweetOptions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tweetOptions.475d9b26.svg";
export { ForwardRef as ReactComponent };